import React from 'react';
import queryString from 'query-string';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import BookingReferenceEditForm from 'Components/BookingReferenceEditForm';
import { bookingReferenceService, userService } from 'Services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';

class BookingReferencePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            isNew: false,
            edit_reference: null
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    fetchData = (br_id) => {

        if (br_id === "-1") {

            var selectedAccount = null;

            if (this.props.router.location && this.props.router.location.state) {
                selectedAccount = this.props.router.location.state.selectedAccount;
            }

            this.setState({
                loaded: true,
                isNew: true,
                edit_reference: {
                    id: '',
                    account: selectedAccount,
                    reference: '',
                    markup: ''
                }
            });
            
            return;
        }

        bookingReferenceService.getBookingReference(br_id)
            .then(response => {
                if (response.status === 200) {
                    var bookingReference = response.data;

                    this.setState({
                        loaded: true,
                        isNew: false,
                        edit_reference: {
                            id: bookingReference.id,
                            account: bookingReference.account,
                            reference: bookingReference.reference,
                            markup: bookingReference.markup
                        }
                    });
                }
            })
            .catch(error => console.log(error));
    }

    componentDidMount() {
        const values = queryString.parse(this.props.router.location.search);
        this.fetchData(values.id);
    }

    onFormSubmit(formData) {
        var data = {};

        formData.forEach((value, key) => {
            data[key] = value;
        });

        var navigate = this.props.router.navigate;

        bookingReferenceService.submitBookingReference(data)
            .then(response => {
                if (response.status === 200) {
                    navigate('/admin_booking_references');
                } else if (response.status === 201) {
                    this.setState({
                        isNew: false
                    });
                    navigate('/admin_booking_references');
                } else {
                    console.log(response);
                    if (response.message !== undefined && response.message !== null)
                        alert(response.message);
                }
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
    }

    render() {

        if (!this.state.loaded)
            return (<LoadingPageContent />);

        var accountOptions = null;

        if (this.props.authenticatedUser) {
            accountOptions = this.props.authenticatedUser.accounts;
        }

        

        return (
            <div id="bookingReference">
                <Navigation  authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">{this.state.isNew ? "Add" : "Edit"} Booking Reference</div>
                    </div>
                    <div className="padding-tb10" />
                    <div className="row">
                        <div className="col-sm-12">
                            <BookingReferenceEditForm
                                isNew={this.state.isNew}
                                accountOptions={accountOptions}
                                edit_reference={this.state.edit_reference}
                                onFormSubmit={this.onFormSubmit} />
                        </div>
                    </div>
                    
                </div>
            </div>
            );
    }
}

const AuthenticatedBookingReferencePage = withAuthenticatedUser(withRouter(BookingReferencePage));

export { AuthenticatedBookingReferencePage as BookingReferencePage };
